<div class="xvi-integer-renderer" [ngClass]="class">
  <div class="counter" [ngClass]="{ 'buttons-enabled': hideButtons }">
    <!--  input type set as 'text', since 'number' doesn't support selectionStart and setSelectionRange  -->
    <input
      #countInput
      [ngClass]="class"
      [attr.type]="'text'"
      [attr.step]="step"
      [attr.min]="min"
      [attr.max]="max"
      [attr.disabled]="disabled ? 'true' : null"
      [placeholder]="placeholder"
      (keyup)="onKeyup($event)"
      (keydown)="onKeydown($event)"
      (focusin)="onFocusIn($event)"
      (focusout)="onFocusOut($event)"
      (gridCustomFocus)="onGridCustomFocus($event)"
      [(ngModel)]="value"
      [attr.customScanning]="true"
    />
    <button
      #minusButton
      *ngIf="!hideButtons"
      tabindex="-1"
      class="btn btn-counter btn-minus"
      type="button"
      [disabled]="decreaseButtonDisabled"
      (click)="decrease(true, $event)"
      (keydown)="onMinusButtonKeyDown($event)"
      (keyup)="buttonKeyup($event)"
      [attr.customScanning]="true"
    >
      <i class="glyphicon glyphicon-minus"></i>
    </button>
    <button
      #plusButton
      *ngIf="!hideButtons"
      tabindex="-1"
      class="btn btn-counter btn-plus"
      type="button"
      [disabled]="increaseButtonDisabled"
      (click)="increase(true, $event)"
      (keydown)="onPlusButtonKeyDown($event)"
      (keyup)="buttonKeyup($event)"
      [attr.customScanning]="true"
    >
      <i class="glyphicon glyphicon-plus"></i>
    </button>
  </div>
</div>
